import { useParams, useNavigate } from "react-router-dom";
import { CustomerPage as CustomerPageView } from "@/components/CustomerPage";
import { useModules } from "@/auth/ModulesContext";
import { useWhatsAppEnabled } from "@/hooks/useWhatsAppEnabled";

export function CustomerPage() {
  const { customerId } = useParams<{ customerId: string }>();
  const navigate = useNavigate();
  const { hasModule, modules } = useModules();
  const whatsAppEnabled = useWhatsAppEnabled();

  if (!customerId) return null;

  return (
    <CustomerPageView
      customerId={customerId}
      onBack={() => navigate("/customers")}
      onDeleted={() => navigate("/customers")}
      onInvoiceClick={(invoiceId) => navigate(`/invoices/${invoiceId}`)}
      onCreditNoteClick={(creditNoteId) => navigate(`/credit-notes/${creditNoteId}`)}
      // Resolved entitlement: hasModule is optimistic while loading, and a panel that then vanishes is worse.
      eInvoicingEnabled={modules !== null && hasModule("ar.e_invoicing")}
      whatsAppEnabled={whatsAppEnabled}
    />
  );
}
